(function(){
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, {rootMargin:'0px 0px -8% 0px'}) : null;
  function init(root){
    root.querySelectorAll('.nff-rv:not(.is-in)').forEach(function(el){ io ? io.observe(el) : el.classList.add('is-in'); });
    root.querySelectorAll('[data-nff-ba]').forEach(function(w){
      var r = w.querySelector('input[type=range]');
      if(r && !r.dataset.bound){ r.dataset.bound = 1; r.addEventListener('input', function(){ w.style.setProperty('--pos', r.value + '%'); }); }
    });
  }
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-yt]');
    if(!b || b.querySelector('iframe')) return;
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + b.dataset.yt + '?autoplay=1&playsinline=1&rel=0&modestbranding=1';
    f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    f.allowFullscreen = true;
    f.title = b.getAttribute('aria-label') || 'Video';
    b.innerHTML = ''; b.appendChild(f);
  });
  init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
